import React, {useEffect, useState } from 'react';
import { ENDPOINTS, WEB_URL } from "@/config/endpoints";
import Link from "next/link";
import dynamic from 'next/dynamic';
import { FormProvider } from '@/component/shared/contactForm/formContext';
import Head from 'next/head';
import { getBreadcrumbSchema } from '@/lib/htsChapterBreadcrumbSchema';

const HTSSearch = dynamic(()=> import('@/component/shared/hts-search/htsSearch'),{loading: () => <p>Loading...</p>})
const ContactFormStep1 = dynamic(() => import('@/component/shared/contactForm/contactFormStep1'), {
  loading: () => <p>Loading...</p>
})
const ContactFormStep2 = dynamic(() => import('@/component/shared/contactForm/contactFormStep2'), {
  loading: () => <p>Loading...</p>
})

const chapter = ({ id, chapterDescription, allChapterData }) => {
  const [chapterNO, setchapterNO] = useState("");
  const [showChapterListSection, setshowChapterListSection] = useState(false);
  const [mWidth, setMWidth] = useState(0);
  const [showNextStep, setShowNextStep] = useState(false);

  const showSteps = () => {
    setShowNextStep(true)
  }
  const showFirstStep = () => {
    setShowNextStep(false)
  }

  useEffect(() => {
    getChapterList(id);
    handleWindowResize();
    window.addEventListener('load', handleWindowResize);
    // unsubscribe from the event on component unmount
    return () => window.removeEventListener('resize', handleWindowResize);

  }, [id])
  const handleWindowResize = () => {
    setMWidth(window.innerWidth);
  }

  async function getChapterList(chapter) {
    setchapterNO(chapter);
    setshowChapterListSection(true);
  }
  
  function textCapitalized(value) {
    if (value != null) {
      const loweredCase = value.toLowerCase();
      return value[0].toUpperCase() + loweredCase.slice(1);
    }
  }

  const chapterBreadcrumbSchema = getBreadcrumbSchema({
    homeUrl: WEB_URL,
    page: 'hts-code',
    chapterName: `Chapter `+ id,
  });

  return (
    <main className='mt-sp-100 sm:mt-20'>
       <Head>
        <title>{`HTS Code for ${chapterDescription} - Chapter ${id}`}</title>
        <meta name="description" content={`Explore HTS Codes for Chapter ${id}. Check tariff rates and duty structure for ${chapterDescription}`}/>
        {/* OpenGraph tags */}
        <meta property="og:title" content={`HTS Code for ${chapterDescription} - Chapter ${id}`}/>
        <meta property="og:description" content={`Explore HTS Codes for Chapter ${id}. Check tariff rates and duty structure for ${chapterDescription}`} />
        <meta property="og:url" content={WEB_URL + '/hts-code/chapter/' + JSON.stringify(id).replace(/^"(.*)"$/, '$1')} />
        <link rel="canonical" href={WEB_URL + '/hts-code/chapter/' + JSON.stringify(id).replace(/^"(.*)"$/, '$1')} />
        <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(chapterBreadcrumbSchema) }}
      />
      </Head>
      <HTSSearch />
     
        <div className={` ${showChapterListSection ? 'block' : 'hidden'}`}>
          <section className="bg-white py-20">
            <div className="container px-3  lg:px-3 xm:px-2">
              <div className="flex flex-wrap">
                <div className="w-[60%] md:w-full sm:w-full pr-4 sm:pr-0 md:pr-0">
                  <div className="mb-5">
                    <p className="text-sm text-secondary mb-3">
                      <Link href={WEB_URL} rel="noopener noreferrer">
                        <span
                          className="text-[#2369d8] cursor-pointer font-sm">
                          {" "}
                          Home {"  "}
                        </span>
                      </Link>
                      {"  "}{" > "}
                      <Link href={WEB_URL+`/hts-code`} rel="noopener noreferrer">
                        <span
                          className="text-[#2369d8] cursor-pointer font-sm">
                          {" "}
                          HTS Codes {"  "}
                        </span>
                      </Link>
                      {"  "}
                      {" >  Chapter"} {id}
                      <span className="font-bold">{ }</span>
                    </p>
                      <h1 className="text-base text-secondary ">
                      <strong className="font-bold"> Chapter {id} </strong> - HTS Codes for {chapterDescription}</h1>
                  </div>
                  {mWidth > 728 ?
                    <div className="mt-8 flow-root">
                      <div className="overflow-x-auto">
                        <div className="inline-block min-w-full align-middle">
                          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg">
                            <table className="min-w-full">
                              <thead className="bg-gray-50">
                                <tr className="bg-[#B5B5B5] rounded-t-lg">
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    HTS Code
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                  >
                                    Description
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                  ></th>
                                </tr>
                              </thead>
                              <tbody className="bg-white">
                                {allChapterData.map((data) => {
                                  return (
                                  (data.htsCode && 
                                  <tr className="odd:bg-[#F5F9FC]" key={data.htsCode}>
                                    <td
                                      style={{ width: "150px" }}
                                      className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                                    >
                                      <Link className='text-anchor-blue hover:text-yellowcolor hover:underline ' href={WEB_URL+`/hts-code/${String(data.htsCode).replace(/\./g, "")}`}>{data.htsCode}</Link>
                                    </td>
                                    <td className="whitespace-wrap px-3 py-4 text-sm text-gray-500">
                                      {textCapitalized(data.description)}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      <Link
                                        href={WEB_URL+`/hts-code/${String(data.htsCode).replace(/\./g, "")}`}
                                         className="border border-brand text-sm font-medium py-1 px-2 rounded-[10px] text-brand hover:bg-gradient-to-r hover:from-[#022B5C] hover:to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:text-white"
                                      >
                                        View
                                      </Link>
                                    </td>
                                  </tr>
                                  )
                                )})}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div className='justify-between flex mt-3'>
                          {chapterNO > 1 &&
                            <Link className='text-sm hover:underline' href={WEB_URL+`/hts-code/chapter/${chapterNO <= 9 ? '0' : ''}${chapterNO - 1}`}>Go to Previous Chapter - Chapter {chapterNO <= 9 ? '0' : ''}{chapterNO - 1}</Link>
                          }

                          {chapterNO == 99 ?
                            '' : <Link className='text-sm hover:underline text-right' href={WEB_URL+`/hts-code/chapter/${(Number(chapterNO) + 1) <= 9 ? '0' : ''}${Number(chapterNO) + 1}`}>Go to Next Chapter - Chapter {(Number(chapterNO) + 1) <= 9 ? '0' : ''}{Number(chapterNO) + 1}</Link>
                          }
                        </div>

                      </div>
                    </div>
                    :
                    <div>
                      <div className="mx-auto sm:w-auto">
                        {allChapterData.map((data) => {
                          return (
                            (data.htsCode && 
                            <div key={data.htsCode}>
                              <div className="mt-8 odd:bg-[#F5F9FC] p-2" >
                                <div
                                  className="flex item-center pb-xsp"
                                >
                                  <span className="text-sm text-secondary font-bold mr-2">
                                    <Link className='text-anchor-blue hover:text-yellowcolor hover:underline' href={WEB_URL+`/hts-code/${String(data.htsCode).replace(/\./g, "")}`}> {data.htsCode}{" "}</Link>
                                  </span>
                                </div>

                                <div className="flex item-center pb-xsp">
                                  <span className="text-sm text-secondary">
                                    {" "}
                                    {textCapitalized(data.description)}
                                  </span>
                                </div>

                                <div className="flex item-center pb-xsp mt-1">
                                  <Link
                                    href={WEB_URL+`/hts-code/${String(data.htsCode).replace(/\./g, "")}`}
                                    className="bg-brand text-white border border-brand text-sm font-bold py-1 px-2 hover:bg-white hover:text-brand hover:border hover:border-brand rounded-[10px]"
                                  >
                                    View
                                  </Link>
                                </div>
                              </div>
                            </div>)
                          );
                        })}
                      </div>

                      <div className='justify-between flex mt-3 mb-4'>
                        {chapterNO > 1 &&
                          <Link className='text-sm hover:underline' href={WEB_URL+`/hts-code/chapter/${chapterNO <= 9 ? '0' : ''}${chapterNO - 1}`}>Go to Previous Chapter - Chapter {chapterNO <= 9 ? '0' : ''}{chapterNO - 1}</Link>
                        }
                        {chapterNO == 99 ?
                          '' : <Link className='text-sm hover:underline text-right' href={WEB_URL+`/hts-code/chapter/${(Number(chapterNO) + 1) <= 9 ? '0' : ''}${Number(chapterNO) + 1}`}>Go to Next Chapter - Chapter {(Number(chapterNO) + 1) <= 9 ? '0' : ''}{Number(chapterNO) + 1}</Link>
                        }
                      </div>

                    </div>
                  }
                </div>
                <div className="w-[39%] md:w-full sm:w-full">
                  <div className='lg:sticky xm:top-[130px] xm:sticky md:mt-5 lg:top-[100px] '>
                    <div className='mb-5'>
                      <FormProvider>
                        {!showNextStep ?
                          <ContactFormStep1 showStep1={showSteps} /> :
                          <ContactFormStep2 showPrevStep={showFirstStep} formType="GetInTouchNew" />
                        }
                      </FormProvider>
                    </div>
                  </div>
                </div>
              </div>

            </div>


          </section>
        </div>
    </main>
  );
};
export default chapter;

export async function getServerSideProps(context) {
  const { res } = context;
  const id = context.params.index;

  let allChapterData = {};
  let chapterDescription = '';

  if (!id || id === "null" || id === "undefined") {
    return { notFound: true };
  }

  try {
    // Fetch chapter data
    const chapterRes = await fetch(
      `${ENDPOINTS.HTS_CODE_API}hts-codes?chapter=${id}&start=0&size=1000`,
      { headers: { 'Content-Type': 'application/json' } }
    );

    if (chapterRes.status === 500) {
      console.error(`Server error (500) while fetching chapter ${id}`);
      res.statusCode = 500;
      return { notFound: true };
    }

    if (!chapterRes.ok) {
      throw new Error(`Failed to fetch chapter data: ${chapterRes.status}`);
    }
    allChapterData = await chapterRes.json();

    // Fetch grouped chapter descriptions
    const descriptionRes = await fetch(
      `${ENDPOINTS.HTS_CODE_API}grouped-chapters?start=0&size=99`,
      { headers: { 'Content-Type': 'application/json' } }
    );

    if (!descriptionRes.ok) {
      throw new Error(`Failed to fetch chapter descriptions: ${descriptionRes.status}`);
    }

    const chapterDescriptionData = await descriptionRes.json();

    for (const section of chapterDescriptionData) {
      const foundChapter = section.chapters.find(chap => String(chap.chapter) === String(id));
      if (foundChapter) {
        chapterDescription = foundChapter.description;
        break;
      }
    }

    if (Number(id) > 99) {
      res.statusCode = 500;
      return { notFound: true };
    }
  } catch (error) {
    console.error("Error fetching chapter data or descriptions:", error);
    res.statusCode = 500;
    return { notFound: true };
  }
  return {
    props: {
      id,
      chapterDescription,
      allChapterData,
    },
  };
}

